import { Form, Input, FormFeedback, Button } from "reactstrap";
import { useHistory, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import { verifyAuth } from "../../api/auth";
import ResultHandler from "../../components/ResultHandler";
import logo from "../../assets/images/QN-logo-mini.png";
import useCustomValidation from "../dashboard/validationSchema";
import { useResponse } from "../../hooks/useResponse";
import { handleLoginSuccess } from "../../utils/handleLoginSuccess";
import { useRecoilState } from "recoil";
import authState from "../../atom/auth";

const LoginTwoFactorAuth = () => {
  const { twoFactorVerificationSchema } = useCustomValidation();
  const [isLogged, setIsLogged] = useRecoilState(authState);
  const history = useHistory();
  const location = useLocation();
  const authenticity_token = location.state?.authenticity_token;

  // Verify
  const { setData, loading, error } = useResponse(verifyAuth, (res) => {
    const data = res.data;
    setIsLogged(true);
    handleLoginSuccess(data, history);
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: { code: "" },
    validationSchema: twoFactorVerificationSchema,
    onSubmit: (values) => {
      setData({ type: "add", data: { ...values, authenticity_token } });
    },
  });

  return (
    <div style={{ minHeight: "100vh" }}>
      <div
        className="text-start w-100 p-3"
        style={{ cursor: "pointer" }}
        onClick={() => history.goBack()}
      >
        <i class="bx bx-arrow-back font-size-16 fw-bold"></i>
      </div>

      <div className="d-flex justify-content-center align-items-center flex-column">
        <div
          className="d-flex justify-content-center align-items-center flex-column p-3"
          style={{ width: "500px", maxWidth: "100%" }}
        >
          <div style={{ height: "80px", width: "80px" }}>
            <img src={logo} alt="logo" className="w-100 h-100" />
          </div>

          <div className="w-100 mt-4">
            <Form className="form-horizontal" onSubmit={formik.handleSubmit}>
              <div className="mb-3">
                <h5
                  style={{
                    fontSize: "17px",
                    fontWeight: "600",
                    borderLeft: "3px solid",
                    paddingLeft: "10px",
                    marginBottom: "16px",
                  }}
                >
                  Enter Verification Code
                </h5>
                <Input
                  name="code"
                  className="form-control"
                  type="text"
                  placeholder="Verification code"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.code || ""}
                  invalid={
                    formik.touched.code && formik.errors.code ? true : false
                  }
                />
                {formik.touched.code && formik.errors.code ? (
                  <FormFeedback type="invalid">
                    {formik.errors.code}
                  </FormFeedback>
                ) : null}
              </div>

              <p style={{ fontWeight: "600" }} className="">
                Enter the code from your two-factor authintication app.
              </p>

              <ResultHandler error={error} />

              <Button
                color="primary"
                type="submit"
                disabled={loading}
                className="w-100 fw-bold"
              >
                {loading ? "Loading..." : "Verify code"}
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginTwoFactorAuth;
